/**
 *
 * @module entry
 * @desc {SDK.UserActivity.Glimpse} entry point.
 *
 */

import GlimpseEvent from './glimpseEvent';
import GlimpseEvents from './glimpseEvents';


/**
 *
 * @type {Object}
 *
 * @property {GlimpseEvent} GlimpseEvent
 * @property {GlimpseEvents} GlimpseEvents
 *
 */

/**
 *
 * @type {SDK.UserActivity.Glimpse}
 *
 */
export default {

    GlimpseEvent,
    GlimpseEvents

};



// WEBPACK FOOTER //
// ./src/userActivity/glimpse/entry.js